import { Icon, Spinner } from "@deligoo/ui"
import clsx from "clsx"
import { memo } from "react"
import { useTranslation } from "react-i18next"

import { DataStatus } from "@/types"

import cls from "./Status.module.scss"

type StatusProps = {
  type: DataStatus | "updating" | null
  title: string
  fullHeight: boolean
}

export const Status = memo(({ type, title, fullHeight }: StatusProps) => {
  const { t } = useTranslation()

  return (
    <div className={clsx(cls.Status, fullHeight && cls.fullHeight)}>
      <div className={cls.title}>{title}</div>

      {type === "loading" && (
        <>
          <div style={{ padding: "1rem" }}>
            <Spinner className={cls.icon} />
          </div>
          {t("loading_data")}
        </>
      )}

      {type === "error" && (
        <>
          <Icon name="warnings" size="large" color="alert" className={cls.icon} />
          {t("error_loading_data")}
        </>
      )}

      {type === "no_team" && (
        <>
          <Icon name="team" size="large" color="alert" className={cls.icon} />
          {t("no_team")}
        </>
      )}
    </div>
  )
})
